import { geo, Strategy } from 'ultimap';
import L from 'leaflet';

// export const ugeo = geo;
// export const ugeo = geo.setStrategy(new Strategy.Yandex());
export const TILE_MOYDOM = window.BaseApp.initData.mapTile;

export const ugeo = geo.setStrategy(
    new Strategy.Leaflet({
        tileLayerProviderLink: TILE_MOYDOM,
        copyrights: [
            '© Moydom',
            '© <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a> contributors',
        ],
    })
);

export const leafetLayer = L.tileLayer(TILE_MOYDOM, {
    attribution: 'Data © <a href="http://osm.org/copyright">OpenStreetMap</a>',
    maxZoom: 20,
    minZoom: 11,
});

export const sputnikMap = L.tileLayer(
    'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'
);

export const DEFAULT_ICON_URL = '/images/map/pin.png';

// export const defaultIcon = config.style.icon('/images/map/pin.png');

export const polygonDefaultStyle = {
    fillColor: '#df362a',
    fillOpacity: 0.33,
    strokeColor: '#df362a',
    strokeOpacity: 0.5,
    strokeWidth: 2,
};

export const markerDefaultStyle = {
    src: './map-marker.png',
    size: [34, 46],
    offset: [17, 46],
};
